var _tablas_tasks;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var labels = {
  response_request: {
    es: 'Respuesta',
    en: 'Request Response'
  },
  table_assignment: {
    es: 'Asignación de tablas',
    en: 'Table assignment'
  },
  bulk_load: {
    es: 'Carga masiva',
    en: 'Bulk load'
  },
  download_metadata: {
    es: 'Descargar metadatos',
    en: 'Download metadata'
  },
  do_update: {
    es: 'Actualizar operador de datos',
    en: 'Data operator update'
  },
  add_tables: {
    es: 'Sincronizar tablas',
    en: 'Add tables with cron'
  },
  tableau_objects: {
    es: 'Objetos de Tableau',
    en: 'Tableau Objects'
  },
  datasource_assignment: {
    es: 'Asignación de datasources',
    en: 'Datasource assignment'
  },
  dashboard_assignment: {
    es: 'Asignación de dashboards',
    en: 'Dashboard assignment'
  },
  powerbi_objects: {
    es: 'Objetos de PowerBI',
    en: 'PowerBI Objects'
  },
  dataset_assignment: {
    es: 'Asignación de datasets',
    en: 'Dataset assignment'
  },
  report_assignment: {
    es: 'Asignación de reportes',
    en: 'Report assignment'
  },
  lds_objects: {
    es: 'Objetos de Looker Data Studio',
    en: 'Looker Data Studio Objects'
  },
  report_lds_assignment: {
    es: 'Asignación de reportes LS',
    en: 'LS Report assignment'
  },
  datasource_ls_assignment: {
    es: 'Asignación de datasources LS',
    en: 'LS Datasource assignment'
  },
  visualization_access: {
    es: 'Accesos',
    en: 'Visualization access'
  },
  subtitle_table_assignment: {
    es: 'Lista de tablas no productivas en INCA Platform. Esto significa que los usuarios de la plataforma no pueden visualizarlas. Para publicar una tabla y hacerlo visible a los usuarios será necesario registrar su metadata, asignar un data operator y cambiar el enviroment de dev a prod.',
    en: 'List of non-production tables in INCA Platform. This means that platform users cannot view them. To publish a table and make it visible to users, it will be necessary to register its metadata, assign a data operator, and change the environment from dev to prod.'
  },
  subtitle_bulk_load: {
    es: 'Permite registrar la metadata de un elemento o elementos de forma masiva. Se puede descargar la plantilla, completar los datos solicitados e importar el archivo nuevamente.',
    en: 'This allows registering the metadata of one or more elements in bulk. You can download the template, fill in the requested data, and import the file again.'
  },
  subtitle_download_metadata: {
    es: 'Lista de tablas productivas y no productivas de la organización que INCA Platform puede visualizar. Se puede descarga la metadata general de las tablas general o seleccionar las tablas y descargar la metadata total de cada uno de los elementos seleccionados.',
    en: 'List of productive and non-productive tables of the organization that INCA Platform can view. You can download the general metadata of the tables or select the tables and download the complete metadata of each of the selected elements.'
  },
  subtitle_do_update: {
    es: '',
    en: ''
  },
  subtitle_add_tables: {
    es: 'Permite sincronizar una tabla no visible del proyecto de la organización con INCA Platform.',
    en: "This allows synchronizing a non-visible table from the organization's project with INCA Platform."
  },
  subtitle_datasource_assignment: {
    es: 'Permite gestionar la metadata, términos de negocios asociados, linaje y asignación de operator del objeto Data Source proveniente de Tableau.',
    en: 'This allows managing the metadata, associated business terms, lineage, and operator assignment of the Data Source object from Tableau.'
  },
  subtitle_dashboard_assignment: {
    es: 'Permite gestionar la metadata, vistas del dashboard, términos de negocios asociados, linaje y asignación de operator del objeto Dashboard proveniente de Tableau.',
    en: 'This allows managing the metadata, dashboard views, associated business terms, lineage, and operator assignment of the Dashboard object from Tableau.'
  },
  subtitle_dataset_assignment: {
    es: '',
    en: ''
  },
  subtitle_report_assignment: {
    es: '',
    en: ''
  },
  subtitle_report_lds_assignment: {
    es: 'Permite el registro de reportes creados en Looker Data Studio. Se necesitará complentar el url del reporte y metadata, páginas y asociar términos de negocios.',
    en: 'This allows registering reports created in Looker Data Studio. You will need to complete the report URL and metadata, pages, and associate business terms.'
  },
  subtitle_visualization_access: {
    es: 'Informe de accesos brindados a los objetos que están publicados en el módulo de Gestión de datos en INCA Platform.',
    en: 'Report of accesses granted to objects published in the Data Management module in INCA Platform.'
  },
  modals: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    nivel: 2,
    general: {
      es: 'General',
      en: 'General'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    bterm: {
      es: 'Término de negocio',
      en: 'Business term'
    },
    profiling: {
      es: 'Perfilamiento',
      en: 'Profiling'
    },
    profiling_dp: {
      es: 'Perfilamiento',
      en: 'Profiling'
    },
    quality_dp: {
      es: 'Calidad de Datos',
      en: 'Data Quality'
    },
    lineage: {
      es: 'Linaje',
      en: 'Lineage'
    },
    hlogs: {
      es: 'Historial de registros',
      en: 'History logs'
    },
    sample_data: {
      es: 'Muestra de datos',
      en: 'Data sample'
    },
    sample_data_hint: {
      es: 'Muestra de hasta {n} registros. Las columnas marcadas como sensibles se muestran enmascaradas.',
      en: 'Sample of up to {n} records. Columns marked as sensitive are shown masked.'
    },
    sample_data_empty: {
      es: 'La tabla no tiene registros para mostrar.',
      en: 'The table has no records to show.'
    },
    sample_data_error: {
      es: 'No se pudo obtener la muestra de datos en este momento. Intenta nuevamente más tarde.',
      en: 'The data sample could not be loaded right now. Please try again later.'
    },
    sample_data_load: {
      es: 'Cargar muestra',
      en: 'Load sample'
    },
    organization: {
      es: 'Organización',
      en: 'Organization'
    },
    official_source: {
      es: 'Fuente de datos',
      en: 'Data source'
    },
    environment: {
      es: 'Entorno',
      en: 'Environment'
    },
    domain: {
      es: 'Dominio',
      en: 'Domain'
    },
    subdomain: {
      es: 'Subdominio',
      en: 'Subdomain'
    },
    operator: {
      es: 'Operador',
      en: 'Operator'
    },
    public: {
      es: 'Público',
      en: 'Public'
    },
    authorization_type: {
      es: 'Tipo de autorización',
      en: 'Authorization type'
    },
    authorization_type_manual: {
      es: 'Manual',
      en: 'Manual'
    },
    authorization_type_automatic: {
      es: 'Automático',
      en: 'Automatic'
    },
    auto_approve_confirm: {
      es: 'Esta acción marcará la tabla como aprobación automática: se aprobarán todas las solicitudes de acceso pendientes de esta tabla y las futuras se aprobarán automáticamente. Las aprobaciones automáticas se otorgan por un máximo de 3 meses. ¿Deseas continuar?',
      en: 'This action will mark the table as automatic approval: all pending access requests for this table will be approved and future ones will be auto-approved. Automatic approvals are granted for a maximum of 3 months. Do you want to continue?'
    },
    zone: {
      es: 'Zona',
      en: 'Zone'
    },
    area: {
      es: 'Área',
      en: 'Area'
    },
    upload_platform: {
      es: 'Plataforma de Carga',
      en: 'Upload Platform'
    },
    upload_process: {
      es: 'Proceso de Carga',
      en: 'Upload Process'
    },
    table_desc: {
      es: 'Descripción de la tabla',
      en: 'Table description'
    },
    required: {
      es: 'Este campo es requerido',
      en: 'This field is required'
    },
    email_invalid: {
      es: 'El correo debe ser válido',
      en: 'E-mail must be valid'
    },
    files: {
      es: 'Archivos',
      en: 'Files'
    },
    attach: {
      es: 'Adjuntar',
      en: 'Attach'
    },
    filter: {
      es: 'Filtrar',
      en: 'Filter'
    },
    type_search: {
      es: 'Escribe para buscar',
      en: 'Type to search'
    },
    column: {
      es: 'Columna',
      en: 'Column'
    },
    data_element: {
      es: 'Nombre de elemento de datos',
      en: 'Data element name'
    },
    bdefinition: {
      es: 'Definición de negocio',
      en: 'Business definition'
    },
    transformation_logic: {
      es: 'Lógica de transformación',
      en: 'Transformation logic'
    },
    sensitive: {
      es: 'Sensible',
      en: 'Sensitive'
    },
    type: {
      es: 'Tipo',
      en: 'Type'
    },
    length: {
      es: 'Tamaño',
      en: 'Length'
    },
    valid_values: {
      es: 'Valores válidos',
      en: 'Valid values'
    },
    primary_key: {
      es: 'Llave primaria',
      en: 'Primary key'
    },
    null: {
      es: 'Nulo',
      en: 'Null'
    },
    encrypted: {
      es: 'Encriptado',
      en: 'Encrypted'
    },
    request_reason: {
      es: 'Razón de solicitud',
      en: 'Request reason'
    },
    leyenda_bterm: {
      es: '*Esta pestaña es independiente del flujo de trabajo. Puede grabar el término de negocio sin necesidad de que sea aprobado, siempre y cuando tenga el rol asignado para ello.',
      en: '*This tab is independent of the workflow. You can record the business term without having to be approved, as long as you have the role assigned for it.'
    },
    no_profiling: {
      es: 'No hay reglas definidas para esta tabla.',
      en: 'There are not defined rules for this table'
    },
    set_lineage_date: {
      es: 'Establecer rango de fechas para el linaje:',
      en: 'Set date range for lineage:'
    },
    from: {
      es: 'Del',
      en: 'From'
    },
    to: {
      es: 'Hasta',
      en: 'To'
    },
    connections: {
      es: 'Conexiones',
      en: 'Connections'
    },
    database: {
      es: 'Base de datos',
      en: 'Database'
    },
    description: {
      es: 'Descripción',
      en: 'Description'
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    shared: {
      es: 'Compartido',
      en: 'Shared'
    },
    save_bterms: {
      es: 'Guardar términos de negocio',
      en: 'Save business terms'
    },
    response: {
      es: 'Respuesta',
      en: 'Response'
    },
    log_type: {
      es: 'Tipo de registro',
      en: 'Log type'
    },
    views: {
      es: 'Vistas',
      en: 'Views'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    user_access: {
      es: 'Accesos de usuario',
      en: 'User access'
    },
    workspace: {
      es: 'Espacio de trabajo',
      en: 'Workspace'
    },
    app: {
      es: 'Aplicación',
      en: 'App'
    },
    save_tables: {
      es: 'Guardar tablas asignadas',
      en: 'Save assigned tables'
    },
    access_link: {
      es: 'Enlace del acceso',
      en: 'Access link'
    },
    private_access: {
      es: 'Acceso privado',
      en: 'Private access'
    },
    request: {
      es: 'Solicitud',
      en: 'Request'
    },
    request_until: {
      es: 'Solicitar hasta',
      en: 'Request until'
    },
    external_user: {
      es: 'Usuario externo',
      en: 'External user'
    },
    columns_to_request: {
      es: 'Columnas a solicitar',
      en: 'Columns to request'
    },
    user_type: {
      es: 'Tipo de usuario',
      en: 'User type'
    },
    total_columns: {
      es: 'Total de columnas seleccionadas',
      en: 'Total columns selected'
    },
    client_email: {
      es: 'Correo externo',
      en: 'Client email'
    },
    use_case: {
      es: 'Caso de uso',
      en: 'Use case'
    },
    why_need: {
      es: '¿Para qué necesitas estos datos?',
      en: 'Why do you need this data?'
    },
    request_by: {
      es: 'Solicitud de ',
      en: 'Request by'
    },
    table_requested: {
      es: 'Tabla/Vista solicitada',
      en: 'Table/View requested'
    },
    start_date: {
      es: 'Fecha inicio',
      en: 'Start date'
    },
    request_since: {
      es: 'Solicitar desde',
      en: 'Request since'
    },
    bus_data_steward: {
      es: 'Business Data Steward',
      en: 'Business Data Steward'
    },
    data_owner: {
      es: 'Data Owner',
      en: 'Data Owner'
    },
    tech_data_custodiam: {
      es: 'Tech. Data Custodiam',
      en: 'Tech. Data Custodiam'
    },
    load_logic: {
      es: 'Lógica de Carga',
      en: 'Load Logic'
    },
    tables_relationship: {
      es: 'Relación Entre Tablas',
      en: 'Tables Relationship'
    }
  }, "connections", {
    es: 'Conexiones',
    en: 'Connections'
  }), "email_domain_invalid", {
    es: 'El dominio del correo no es válido',
    en: 'The email domain is not valid'
  }), "invalid_bigquery_type", {
    es: 'Tipo de dato BigQuery no válido',
    en: 'Invalid BigQuery data type'
  }), "final_table", {
    es: 'Tabla final',
    en: 'Final table'
  }),
  tablas_tasks: (_tablas_tasks = {
    nivel: 2,
    table: {
      es: 'Tabla',
      en: 'Table'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    rows: {
      es: 'Filas',
      en: 'Rows'
    },
    creation_date: {
      es: 'Fecha de creación',
      en: 'Creation date'
    },
    operator: {
      es: 'Operador',
      en: 'Operator'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    dashboard: {
      es: 'Dashboard',
      en: 'Dashboard'
    },
    views: {
      es: 'Vistas',
      en: 'Views'
    },
    user: {
      es: 'Usuario',
      en: 'User'
    },
    groups: {
      es: 'Grupos',
      en: 'Groups'
    },
    user_inca: {
      es: 'Usuario INCA',
      en: 'INCA user'
    },
    applicant: {
      es: 'Solicitante',
      en: 'Applicant'
    },
    dataset: {
      es: 'Dataset',
      en: 'Dataset'
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_tablas_tasks, "datasource", {
    es: 'Datasource',
    en: 'Datasource'
  }), "environment", {
    es: 'Entorno',
    en: 'Environment'
  }), "report", {
    es: 'Reporte',
    en: 'Report'
  }), "pages", {
    es: 'Páginas',
    en: 'Pages'
  }), "user_pbi", {
    es: 'Usuario PBI',
    en: 'PBI user'
  }), "name", {
    es: 'Nombre',
    en: 'Name'
  }), "end_date", {
    es: 'Fecha fin',
    en: 'End date'
  }), "bterm", {
    es: 'Término de negocio',
    en: 'Business term'
  }), "definition", {
    es: 'Definición',
    en: 'Definition'
  }), "object", {
    es: 'Objeto',
    en: 'Object'
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_tablas_tasks, "owner", {
    es: 'Propietario',
    en: 'Owner'
  }), "sheet_type", {
    es: 'Tipo de hoja',
    en: 'Sheet type'
  }), "title", {
    es: 'Título',
    en: 'Title'
  }), "caption", {
    es: 'Subtítulo',
    en: 'Caption'
  }), "preview", {
    es: 'Previsualizar',
    en: 'Preview'
  }), "values", {
    es: 'Valores',
    en: 'Values'
  }), "total_tables", {
    es: 'Total de tablas',
    en: 'Total tables'
  }), "rol", {
    es: 'Rol',
    en: 'Role'
  }), "actions", {
    es: 'Acciones',
    en: 'Actions'
  })),
  assign: {
    es: 'Asignar',
    en: 'Assign'
  },
  sync: {
    es: 'Sincronizar',
    en: 'Sync'
  },
  assign_modal: {
    es: 'Asignar metadata en entorno prod/dev/test',
    en: 'Assign metadata in prod/dev/test environment'
  },
  search_table: {
    es: 'Buscar por tabla',
    en: 'Search by table'
  },
  search_project: {
    es: 'Buscar por proyecto',
    en: 'Search by project'
  },
  search_column: {
    es: 'Buscar por columna',
    en: 'Search by column'
  },
  search_operator: {
    es: 'Buscar por Operador',
    en: 'Search by Operator'
  },
  search_zone: {
    es: 'Buscar por Zona',
    en: 'Search by Zone'
  },
  search_domain: {
    es: 'Buscar por Dominio',
    en: 'Search by Domain'
  },
  search_subdomain: {
    es: 'Buscar por Subdominio',
    en: 'Search by Subdomain'
  },
  environment: {
    es: 'Entorno',
    en: 'Environment'
  },
  development: {
    es: 'Desarrollo',
    en: 'Development'
  },
  test: {
    es: 'Prueba',
    en: 'Test'
  },
  all: {
    es: 'Todos',
    en: 'All'
  },
  step1: {
    es: 'Paso 1',
    en: 'Step 1'
  },
  step2: {
    es: 'Paso 2',
    en: 'Step 2'
  },
  step3: {
    es: 'Paso 3',
    en: 'Step 3'
  },
  last_step: {
    es: 'Paso anterior',
    en: 'Last step'
  },
  tables: {
    es: 'Tablas',
    en: 'Tables'
  },
  tables_metadata: {
    es: 'Metadata de tablas',
    en: 'Tables metadata'
  },
  columns_metadata: {
    es: 'Metadata de columnas',
    en: 'Columns metadata'
  },
  datasources: {
    es: 'Datasources de Tableau',
    en: 'Tableau Datasources'
  },
  dashboards: {
    es: 'Dashboards de Tableau',
    en: 'Tableau Dashboards'
  },
  bterms: {
    es: 'Términos de negocio',
    en: 'Business Terms'
  },
  select_option: {
    es: 'Selecciona una opción',
    en: 'Select an option'
  },
  download_template: {
    es: 'Descargar plantilla',
    en: 'Download template'
  },
  upload_file: {
    es: 'Subir archivo',
    en: 'Upload file'
  },
  details: {
    es: 'Detalles',
    en: 'Details'
  },
  upload_csv: {
    es: 'Cargar CSV',
    en: 'Upload CSV'
  },
  download_prod: {
    es: 'Descargar tablas productivas',
    en: 'Download prod tables'
  },
  confirm_full: {
    es: 'Confirmar versión completa',
    en: 'Confirm full version'
  },
  want_full: {
    es: '¿Quieres la versión completa?',
    en: 'Do you want the full version?'
  },
  assign_operator: {
    es: 'Asignar operador',
    en: 'Assign data operator'
  },
  project_id: {
    es: 'ID del proyecto',
    en: 'Project ID'
  },
  dataset_id: {
    es: 'ID del dataset',
    en: 'Dataset ID'
  },
  table_name: {
    es: 'Nombre de la tabla',
    en: 'Table name'
  },
  add_tables_legend: {
    es: 'Agregar nuevas tablas sin metadatos a la plataforma INCA (solo si las tablas no existen en la opción Asignación de tablas).',
    en: 'Add new tables without metadata to INCA platform (only if the tables does not exist in the Table assignments option).'
  },
  metadata: {
    es: 'Detalles de la metadata ',
    en: 'Table metadata details'
  },
  object_name: {
    es: 'Nombre de objeto',
    en: 'Object Name'
  },
  path_name: {
    es: 'Nombre de ruta',
    en: 'Path name'
  },
  dev_test: {
    es: 'Desarrollo/Prueba',
    en: 'Development/Test'
  },
  production: {
    es: 'Producción',
    en: 'Production'
  },
  request_reason: {
    es: 'Razón de solicitud',
    en: 'Request reason'
  },
  response_reason: {
    es: 'Respuesta a la solicitud',
    en: 'Response reason'
  },
  view: {
    es: 'Ver',
    en: 'View'
  },
  email_details: {
    es: 'Ver correos',
    en: 'View emails'
  },
  new_email: {
    es: 'Asignar nuevo correo',
    en: 'Assign new email'
  },
  permission: {
    es: 'Ver permisos',
    en: 'View permission'
  },
  audit_logs: {
    es: 'Registros de auditoría',
    en: 'Audit logs'
  },
  download_csv: {
    es: 'Descargar CSV',
    en: 'Download CSV'
  },
  deactivate: {
    es: 'Desactivar',
    en: 'Deactivate'
  },
  activate: {
    es: 'Activar',
    en: 'Activate'
  },
  delete: {
    es: 'Eliminar',
    en: 'Delete'
  },
  no_objects: {
    es: 'No hay objetos para asignar',
    en: 'No objects to assign'
  },
  no_objects_subtitle: {
    es: 'Cuando los haya podrás asignarlos aquí',
    en: 'When there are, you can assign them here'
  },
  user_tableau: {
    es: 'Usuario de Tableau',
    en: 'Tableau user'
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  text_filter: {
    es: 'Filtro de texto',
    en: 'Text filter'
  },
  update_metadata: {
    es: 'Actualizar metadata',
    en: 'Update metadata'
  },
  copy_id: {
    es: 'Copiar ID de vista',
    en: 'Copy View ID'
  },
  request_access: {
    es: 'Solicitar acceso',
    en: 'Request access'
  },
  set_temporal_do: {
    es: 'Establecer operador temporal',
    en: 'Set temporal data operator'
  },
  open_report_lds: {
    es: 'Abrir en Looker Studio',
    en: 'Open in Looker Studio'
  },
  bigquery: {
    es: 'Ver en BigQuery',
    en: 'See on BigQuery'
  },
  copy_view: {
    es: 'Copiar ID de la vista',
    en: 'Copy View ID'
  },
  manage_access: {
    es: 'Administrar acceso',
    en: 'Manage Access'
  },
  more_actions: {
    es: 'Más acciones',
    en: 'More actions'
  },
  assign_all_do: {
    es: 'Establecer operador temporal a todos los objetos',
    en: 'Assign all objects to temporal operator'
  },
  data_profiling: {
    es: 'Perfilado de datos ',
    en: 'Data profiling'
  },
  execute_profiling: {
    es: 'Ejecutar perfilamiento',
    en: 'Execute profiling'
  },
  choose_profiling: {
    es: 'Elegir regla de perfilamiento',
    en: 'Choose profiling rule'
  },
  access_table: {
    es: 'Tabla de acceso',
    en: 'Access table'
  },
  view_bterm: {
    es: 'Ver término',
    en: 'View Term'
  },
  data_operator: {
    es: 'Operador',
    en: 'Data operator'
  },
  viewer: {
    es: 'Espectador',
    en: 'Viewer'
  },
  check_owners: {
    es: 'Por favor revisar el formato de correo',
    en: 'Please check Owner (email format)'
  },
  check_fields: {
    es: 'Por favor revisar los campos en los tabs General y Columnas',
    en: 'Please check the fields in all tabs (General and Columns)!'
  },
  no_changes: {
    es: 'No se hicieron cambios',
    en: 'No change has been made to the request'
  },
  check_description: {
    es: 'Por favor revisar la descripción de la tabla.(Los siguientes caracteres no están permitidos (,) (|) y (salto de línea))',
    en: 'Please check Table Description (The following characters are not allowed (,) (|) and (line break))'
  },
  check_null: {
    es: 'Llene todos los campos y modifique los null',
    en: 'Please fill all the fields and replace the "null"'
  },
  source: {
    es: 'Fuente',
    en: 'Source'
  },
  form_request_description: {
    en: 'Request to Datasource Datastudio user',
    es: 'Solicitud a usuario Datasource Datastudio'
  },
  form_request_title: {
    en: 'Report Access Request',
    es: 'Solicitud de acceso a reporte'
  }
};
export default labels;